import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import { getDisplayName } from '../getDisplayName'

export const withReadyToRenderGuard = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  const WithReadyToRenderGuard = (props: P) => {
    const [isReady, setIsReady] = useState(false)

    useEffect(() => {
      const checkWindowSize = () => {
        if (typeof window !== 'undefined' && window.innerWidth && window.innerHeight) {
          setIsReady(true)
        }
      }

      checkWindowSize()

      const handleResize = () => {
        checkWindowSize()
      }

      window.addEventListener('resize', handleResize)

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }, [])

    if (!isReady)
      return (
        <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress color="primary" />
        </div>
      )

    return <WrappedComponent {...props} />
  }

  WithReadyToRenderGuard.displayName = `WithReadyToRenderGuard(${getDisplayName(WrappedComponent)})`

  return WithReadyToRenderGuard
}
